import React from 'react'
import { observer, inject } from 'mobx-react'

import ProtectedComponent from '../generic/ProtectedComponent'
import MainContent from './MainContent'
import { Box } from '../generic/Box'
import Title from '../generic/Title'
import Input from '../generic/Input'
import TextArea from '../generic/TextArea'
import Button from '../generic/Button'
import FormRenderer from '../generic/FormRenderer'
import MultiSelect from '../generic/MultiSelect'

const SendMail = inject('sendMailStore', 'productsStore', 'companiesStore')(observer(props => {
  const { sendMailStore, productsStore, companiesStore } = props
  const { subject, body, selectedProducts, isSending, selectedCompanies } = sendMailStore.state
  const { products } = productsStore.state
  const { companies } = companiesStore.state
  console.log(companies)
  const fields = [
    {
      component: Input,
      label: 'Assunto',
      type: 'text',
      name: 'subject',
      id: 'send-mail-subject',
      placeholder: 'Assunto',
      value: subject
    },
    {
      component: TextArea,
      label: 'Corpo do e-mail',
      type: 'text',
      name: 'body',
      id: 'send-mail-body',
      placeholder: 'Corpo do e-mail',
      value: body
    },
    {
      component: MultiSelect,
      label: 'Produtos',
      placeholder: 'Selecionar produtos',
      value: selectedProducts.map(data => {
        return {value: data, label: data}
      }),
      options: products.map(data => {
        return {value: data.name, label: data.name}
      }),
      onChange: selectedOptions => sendMailStore.setSelectedProducts(selectedOptions)
    },
    {
      component: MultiSelect,
      label: 'Empresas',
      placeholder: 'Selecionar empresas',
      value: selectedCompanies.map(data => {
        return {value: data.value, label: data.label}
      }),
      options: companies.map(data => {
        return {value: data.id, label: data.name}
      }),
      onChange: selectedOptions => sendMailStore.setSelectedCompanies(selectedOptions)
    },
    {
      component: Button,
      text: 'Enviar email',
      type: 'submit',
      isLoading: isSending,
      onClick: (event) => {
        event.preventDefault(),
        sendMailStore.sendMail()
      },
      styleClass: 'app-main-button',
      id: 'generate-token-submit'
    }
  ]
  return (
    <ProtectedComponent permission='send_mail'>
      <MainContent>
        <Box>
          <Title>Enviar email</Title>
          <form>
            <FormRenderer fields={fields} store={sendMailStore} />
          </form>
        </Box>
      </MainContent>
    </ProtectedComponent>
  )
}))

export default SendMail



// WEBPACK FOOTER //
// ./src/components/dashboard/SendMail.js